interface Testimonial {
  id: number;
  name: string;
  role: string;
  avatar: string;
  rating: number;
  title: string;
  content: string;
}

interface TestimonialsSectionProps {
  testimonials: Testimonial[];
}

export default function TestimonialsSection({ testimonials }: TestimonialsSectionProps) {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-6xl">
        <div className="text-center mb-12 md:mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs text-foreground-500 uppercase tracking-wider">用户见证</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-3">
            用户口碑，<span className="text-accent-500">实力见证</span>
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            来自全球500万+用户的真实评价，每一个好评都是我们前进的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item, index) => {
            const isFaded = index === testimonials.length - 1;
            return (
              <div
                key={item.id}
                className={`bg-background-50 rounded-lg p-5 md:p-6 ${
                  isFaded ? 'opacity-60' : ''
                }`}
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-sm ${
                        i < item.rating
                          ? 'ri-star-fill text-accent-500'
                          : 'ri-star-line text-foreground-300'
                      }`}
                    ></i>
                  ))}
                </div>
                <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h4>
                <p className="text-sm text-foreground-600 leading-relaxed mb-5 line-clamp-4">
                  {item.content}
                </p>
                <div className="flex items-center gap-3 pt-3 border-t border-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-10 h-10 rounded-full object-cover shrink-0"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                    <p className="text-xs text-foreground-500">{item.role}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}